<template>
	<div class="flex flex-col gap-2 p-2">
		<div class="flex flex-col gap-2">
			<label for="criticality" class="formLabel">Project</label>
			<Select
				placeholder="Select project..."
				v-model="projectId"
				:options="projectList"
				option-value="id"
				option-label="projectName"
				@change="navIframe()"
			>
			</Select>
		</div>
		<div class="iframe-container">
			<iframe :src="iframeURL"></iframe>
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { ApiClient, Project } from "../../entities/NSwagGenerated"
import Select from "primevue/select"

export default defineComponent({
	name: "shinyPOC",
	components: { Select },
	data() {
		let projectList = new Array<Project>()
		const apiClient = new ApiClient(import.meta.env.VITE_API_URL?.toString())
		let projectId = ""
		let iframeURL = "https://cataas.com/cat/says/Hello%20Evan!"

		return { projectList, apiClient, projectId, iframeURL }
	},
	mounted() {
		this.apiClient.projectAll().then((result) => {
			this.projectList = result
		})
	},
	methods: {
		getToken() {
			return localStorage.getItem("token")
		},
		navIframe() {
			this.iframeURL = "http://127.0.0.1:5501/?token=" + this.getToken() + "&projectId=" + this.projectId
		},
	},
	computed: {},
})
</script>

<style scoped>
.iframe-container {
	overflow: hidden;
	/* 16:9 aspect ratio */
	padding-top: 56.25%;
	position: relative;
}

.iframe-container iframe {
	border: 0;
	height: 80%;
	left: 0;
	position: absolute;
	top: 0;
	width: 100%;
	overflow: hidden;
}
</style>
